import { render, staticRenderFns } from "./EvaluationRequestManagmentWrapper.vue?vue&type=template&id=9d3bcb9a"
import script from "./EvaluationRequestManagmentWrapper.vue?vue&type=script&lang=js"
export * from "./EvaluationRequestManagmentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports